<template>
    <Tooltip :text="props.tooltip" position="left" class="items-center size-7">
        <div class="cursor-pointer size-7 hover:rounded-full p-1 transition-all duration-300" 
             :class="props.isFavorite ? 'hover:bg-yellow-100 dark:hover:bg-yellow-900/30' : 'hover:bg-gray-200 dark:hover:bg-slate-700'">
            <svg xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 24 24" 
                stroke-width="1.5" 
                :class="['size-5 transition-colors', props.isFavorite ? 'fill-yellow-400 stroke-yellow-400 hover:fill-yellow-500 hover:stroke-yellow-500' : 'fill-none stroke-gray-700 dark:stroke-gray-200 hover:stroke-gray-900 dark:hover:stroke-white']">
                <path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.563.563 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
            </svg>
        </div>
    </Tooltip>
</template>
<script setup>
import { defineProps } from 'vue';
const props = defineProps({
    tooltip: {
        type: String
    },
    isFavorite: {
        type: Boolean,
        default: false
    }
});
</script>
